<mat-card class="mat-elevation-z3 time-period-panel">
  <button *ngFor="let item of customPresets" mat-button color="accent" (click)="selectPeriod(item)">
    {{ item }}
  </button>
</mat-card>
